import mg from "./mg.png";
import ns from "./ns.png";
import sl from "./sl.png";
import sld from "./sld.png";
import so from "./so.png";
import sts from "./sts.png";
import SetFanBG from "./set-fan-background.png";
import SetFanOverlay from "./set-fan-overlay.png";
import SetLiveBG from "./set-live-background.png";
import SetLiveOverlay from "./set-live-overlay.png";

export const desktopImages = {
  mg,
  ns,
  sl,
  sld,
  so,
  sts,
  SetFanBG,
  SetFanOverlay,
  SetLiveBG,
  SetLiveOverlay,
};
